module.exports = __webpack_public_path__ + "static/media/star.ef5a6033.svg";